import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { __rest as o } from "../_virtual/_tslib.js";
import { jsxs as t, jsx as i } from "react/jsx-runtime";
import { calculateRem as n } from "@vds-core/utilities";
import { Children as e, isValidElement as l, cloneElement as r } from "react";
import { ButtonGroup as d } from "@vds-core/buttons";
import c from "styled-components";
var u = c.div.attrs({
    "data-testid": "modal-footer"
  }).withConfig({
    displayName: "StyledFooter",
    componentId: "VDS__sc-1rp52x8-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: 'flex';\n  width: 100%;\n  flex-shrink: 0;\n  ", ";\n  padding: ", ";\n\n  /* Override Button group bottom padding */\n  @media (min-width: 767px) {\n    div {\n      padding-bottom: 0 !important;\n    }\n  }\n  order: ", ";\n"])), function (_ref) {
    var o = _ref.$fullWidthContent;
    return o && "box-sizing: border-box;";
  }, function (_ref2) {
    var o = _ref2.viewport,
      t = _ref2.$fullWidthContent;
    return "mobile" === o ? n(48, 0, 0, 0) : n(32, t ? 4 : 0, 0, 0);
  }, function (_ref3) {
    var o = _ref3.$closeButton,
      t = _ref3.$footerIndex,
      i = _ref3.$isMobileDevice;
    return null === o && i && t;
  }),
  s = function s(n) {
    var c = n.buttonData,
      s = n.viewport,
      a = n.surface,
      p = n.toggleModal,
      f = n.closeButton,
      m = n.footerIndex,
      v = n.isMobileDevice,
      h = n.fullWidthContent,
      b = function () {
        if (!c || !c.close) return !1;
        var t = c.close,
          i = t.children,
          n = t.onClick,
          e = o(t, ["children", "onClick"]);
        return Object.assign(Object.assign({
          children: i,
          size: "large",
          use: "secondary",
          onClick: function onClick() {
            return o = n, p && "function" == typeof p && (null == p || p()), void (null == o || o());
            var o;
          },
          $noVerticalPadding: !0,
          surface: a
        }, "mobile" === s && {
          width: "100%"
        }), e);
      }(),
      g = function () {
        if (!c || !c.primary) return !1;
        var t = c.primary,
          i = t.children,
          n = t.onClick,
          e = o(t, ["children", "onClick"]);
        return Object.assign(Object.assign({
          children: i,
          size: "large",
          use: "primary",
          onClick: n,
          $noVerticalPadding: !b,
          surface: a
        }, "mobile" === s && {
          width: "100%"
        }), e);
      }(),
      y = [];
    g && y.push(g), b && y.push(b);
    var $ = e.map(n.children, function (o, t) {
      var i, n, e;
      var d = o && l(o),
        c = "Button" === (null === (i = null == o ? void 0 : o.type) || void 0 === i ? void 0 : i.displayName) || "WithManager(Button)" === (null === (n = null == o ? void 0 : o.type) || void 0 === n ? void 0 : n.displayName);
      if (d && c && (null === (e = o.props) || void 0 === e ? void 0 : e.close)) {
        var _i = function _i(t) {
          var i, n;
          null === (n = null === (i = null == o ? void 0 : o.props) || void 0 === i ? void 0 : i.onClick) || void 0 === n || n.call(i, t), null == p || p();
        };
        return r(o, {
          onClick: function onClick(o) {
            return _i(o);
          },
          key: t + 1
        });
      }
      return o;
    });
    return t(u, {
      $closeButton: f ? f.closeButton : null,
      $footerIndex: m ? m.footerIndex : null,
      $isMobileDevice: v ? v.isMobileDevice : null,
      $fullWidthContent: h,
      viewport: s,
      children: [$, y && !!y.length && y.length > 0 && i(d, {
        viewport: s,
        rowQuantity: {
          mobile: 1,
          tablet: "mobile" === s ? 1 : 2,
          desktop: "mobile" === s ? 1 : 2
        },
        data: y,
        surface: a,
        childWidth: "100%"
      })]
    });
  };
s.displayName = "ModalFooter";
export { s as default };